import React from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import Search from "../../common/events/SearchEvents";
import EventList from "./EventList";

export default function CoachDashboardEvents({
  loadingEvents,
  onSearch,
  adjustedHeight,
  events,
  onViewAttendees,
  userRole,
}) {
  return (
    <div className="bg-white shadow-lg rounded-lg p-4 pb-0 border-gray-300 h-full">
      <h2 className="text-xl mb-5 uppercase">EVENTS</h2>
      <Search onSearch={onSearch} placeholder="Search Events" />
      {loadingEvents ? (
        <LoadingSpinner />
      ) : (
        <div
          className="space-y-3 overflow-auto pr-4 -mr-4"
          style={{ height: `${adjustedHeight + 140}px` }}
        >
          {events.length > 0 ? (
            events.map((event, index) => (
              <EventList
                key={index}
                event={event}
                onViewAttendees={() => onViewAttendees(event)}
                showAttendeesButton={
                  userRole === "university" || userRole === "highschool"
                }
              />
            ))
          ) : (
            <div className="w-full p-2 mt-5 flex flex-col items-center">
              <img
                alt="No events that match your search"
                src="/nodata.gif"
                className="object-cover h-20 w-20 rounded-full border-gray-300 border"
              />
              <span className="mt-4 text-center text-md text-slate-600">
                There are no events that match your search
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
